document.addEventListener('DOMContentLoaded', () => {
  // --- セレクタを定数として定義 ---
  const FORM_ID = '#payment-form';
  const USER_ID_SELECTOR = '#user_id';
  const COURSE_ID_SELECTOR = '#user_course_id';
  const START_DATE_SELECTOR = '#user_training_starts_on';
  const HOURS_SELECTOR = '#user_standard_training_hours';
  const RESULT_SELECTOR = '#suggested-end-date';
  const API_ENDPOINT = '/api/admin/course_schedules/suggestion';

  const formId = document.querySelector(FORM_ID);
  if (!formId) {
    return;
  }

  const userIdField = formId.querySelector(USER_ID_SELECTOR)
  const courseIdField = formId.querySelector(COURSE_ID_SELECTOR);
  const startDateField = formId.querySelector(START_DATE_SELECTOR);
  const hoursField = formId.querySelector(HOURS_SELECTOR);
  const resultElement = formId.querySelector(RESULT_SELECTOR);

  // 必要な要素がすべてページ上に存在する場合のみ、処理を実行
  if (courseIdField && startDateField && hoursField && resultElement) {

    // APIを呼び出す関数を定義
    const fetchSuggestedEndDate = () => {
      const courseId = courseIdField.value;
      const startDate = startDateField.value;
      const standardTrainingHours = hoursField.value;
      const user_id = userIdField?.value;

      // 3つの値がすべて入力されている場合のみAPIを呼び出す（ユーザIDは新規時はなし）
      if (!courseId || !startDate || !standardTrainingHours) {
        resultElement.textContent = ''; // 条件を満たさない場合は表示をクリア
        return;
      }

      resultElement.textContent = '（候補日：計算中...）';

      // URLのパラメータを安全に組み立てる
      const params = new URLSearchParams({
        course_id: courseId,
        start_date: startDate,
        standard_training_hours: standardTrainingHours,
        user_id: user_id
      });

      fetch(`${API_ENDPOINT}?${params.toString()}`)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          if (data.suggested_end_date) {
            resultElement.textContent = `（候補日：${data.suggested_end_date}）`;
          } else {
            resultElement.textContent = '（候補日：計算できませんでした。入力値を確認してください。\n選択課題を利用していて、コースを変更した場合、一度ユーザー情報を保存してから、選択課題の設定後に計算されます。）';
          }
        })
        .catch(error => {
          console.error('Fetch error:', error);
          resultElement.textContent = '（候補日：候補日の計算に失敗しました。）';
        });
    };

    // 3つの入力欄すべてに変更があった場合に、上記の関数を実行
    courseIdField.addEventListener('change', fetchSuggestedEndDate);
    startDateField.addEventListener('change', fetchSuggestedEndDate);
    hoursField.addEventListener('change', fetchSuggestedEndDate);

    // 初回に計算させる
    fetchSuggestedEndDate()
  }
});
